const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

type ScribeLayoutCsatEligibility = {
  isLayoutEnabled: boolean;
  isManaged: boolean;
  tourFirstSeenAt?: string;
  nowMs?: number;
};

export const isScribeLayoutCsatEligible = ({
  isLayoutEnabled,
  isManaged,
  tourFirstSeenAt,
  nowMs = Date.now(),
}: ScribeLayoutCsatEligibility): boolean =>
  isLayoutEnabled &&
  !isManaged &&
  !!tourFirstSeenAt &&
  nowMs - Date.parse(tourFirstSeenAt) >= ONE_WEEK_MS;
